import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
const StatusPill = React.forwardRef(function StatusPill2({ tone = "neutral", live = false, icon, className, children, ...rest }, ref) {
  return /* @__PURE__ */ jsxs(
    "span",
    {
      ref,
      className: cx("ev-pill", className),
      "data-tone": tone,
      "data-live": live ? "true" : void 0,
      ...rest,
      children: [
        icon != null && icon !== false ? /* @__PURE__ */ jsx("span", { className: "ev-pill__icon", "aria-hidden": "true", children: icon }) : null,
        children
      ]
    }
  );
});
export {
  StatusPill
};
//# sourceMappingURL=StatusPill.js.map
